module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.30.0.0.box.382.491.963.194.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.30.0.0.box.707.491.309.41.q.80"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.30.0.1.box.382.615.963.70.q.80"
    }
  }, [_vm._v("Company C, Ninth Tennessee")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.1.0.box.214.966.1299.1397.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.30.1.0.box.265.966.1051.99.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  }), _vm._v("Reunion ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Surviving ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Members ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Capt. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("James ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hall's ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Day ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Genuine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Delight ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Veterans. ")]), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.216.1129.1295.154.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.0.0"
    }
  }), _vm._v("The reunion of Company C, Ninth Tennessee regiment seems to have been a very much enjoyed affair. Those who participated in it were highly delighted, enthusiastic in fact.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.2.box.215.1293.1298.100.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.1.0"
    }
  }), _vm._v("The attendance was strictly limited to survivors of the company and their families and the families of deceased comrades.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.3.box.214.1401.1299.855.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.2.0"
    }
  }), _vm._v("Company C, the famous \"Southern Confederates,\" claims to have been the first company organized in Tipton county: It was uniformed and equipped by private enterprise and tendered its services quite a while before the State seceded; the material of which it was composed constituted the flower of the old South; twenty-three of its members were graduates of college or came from college to the company. First and last it numbered about 126 men. Of this number 32 yet survive; 30 were killed in battle, 12 fell victims to the ravages of diseases of the camp, 26 were wounded and disabled. Only 11 were in line of the day of the surrender in North Carolina. Of the survivors ten gathered on the beautiful lawn of Capt. James I. Hall on the 24th, namely Capts. D.J. Wood, James I. Hall and C.B. Simonton, Messrs. J.W. Lemmon, J.S. Hill, J. Forsyth, F. Payne, D.M. McLennan, N. Kimbrough and S.E. Sweet. Their wives and children, together with those of some deceased comrades, made up a party of about forty-eight persons present who reported for duty.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.4.box.214.2265.1298.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.3.0"
    }
  }), _vm._v("The day was ideal—not a cloud and neither hot nor chilly: The spot selected the prettiest in all the county. The affair was"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.1.0.box.214.375.1311.317.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  }), _vm._v("\naltogether informal: no program and nobody wanted to show off, everybody at home. It is true there had been a meeting of the company beforehand to prepare for the reunion and Capt. James I. Hall was chairman and this organization was still in existence, but its hand was not visible; everyone did what seemed right in his own eyes and all seemed to do exactly the right thing.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.1.0.box.214.375.1312.2042.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.1.box.221.702.1305.961.q.60"
    }
  }, [_vm._v("A little past eleven o'clock Capt. Simonton was requested to call the roll of the company. This seemed as if it would be short work and a very perfunctory duty, but it proved to be a highly interesting exercise. As each name was called, if the person was absent, some statement was made of his whereabouts, surroundings and prospects in life. The survivors were found to be scattered from Kentucky to Texas and from Tennessee to Arkansas and California. Interesting letters and postal cards were also read from absent comrades in reply to invitations sent them, regretting their inability to be present and expressing tender regard for the survivors and the memory of the dead. When the name of a dead comrade was read, a statement was made of when and where he died or was killed, with some of the facts connected therewith, or some illustration of his character, and if any family survived him something was given of their whereabouts and conditions in life. When the reader of the roll was in doubt he called upon the comrades present for their information, and often times they volunteered mighty interesting information regarding both dead and living comrades.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.221.1672.1302.206.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.2.0"
    }
  }), _vm._v("This exercise occupied about one hour and a quarter and during this time every member of Company C was remembered and nearly every one of them passed in loving review before the survivors present and their interested families.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.222.1888.1299.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.3.0"
    }
  }), _vm._v("Then came dinner. You have seen and enjoyed tempting, appetizing, exquisite, bountiful and prodigal dinners, but from all accounts none to surpass this one, perhaps none to equal it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.4.box.222.2049.1302.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.4.0"
    }
  }), _vm._v("After dinner comrade S.E. Sweet, of Forrest City, Ark., who lost the whole of his right arm at Chickamauga, besides receiving a painful and dangerous wound in the face and head, and who in camp and on the march beguiled more weary hours and turned them into pleasure than any other man in the army, an irrepressible, fun-loving and mirth-provoking fellow, who has never tired, always cheerful, and in the hour of danger as resolute, aggressive"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.1.0.box.161.357.1300.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _vm._v("\nand cool as an ideal soldier—after dinner Mr. Sweet was introduced to tell some reminiscences. He was too modest to stand, but sitting entertained the whole company of persons present for something like three quarters of an hour with side-splitting and sometime pathetic stories, told in his original manner. Emory, as everybody calls him, could give Private John Allen and our Bob pointers on telling a war story.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.161.357.1300.807.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.162.737.1298.153.q.60"
    }
  }, [_vm._v("At a business meeting of the company it was resolved to have a reunion next year, to be held at the same place on Thursday, the 25th of September.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.161.900.1298.264.q.60"
    }
  }, [_vm._v("An historical committee, consisting of Capt. James I. Hall, C.B. Simonton and Joe Forsyth, were appointed to gather and preserve facts connected wi"), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.3.0.0"
    }
  }), _vm._v("th the history of the company and its members, and a resolution was also passed requesting each survivor and friend of the company to write down the facts"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.214.368.1214.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _vm._v("\nwithin his knowledge and send to the historical committee.")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.32.2.0.box.160.1212.1302.1213.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0019.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.214.368.1305.2038.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.216.423.1298.152.q.60"
    }
  }, [_vm._v("Altogether it was, from the testimony of those participating, as enjoyable a reunion as has ever been held: everyone present expressed a desire to attend another.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.217.584.1302.143.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.2.0"
    }
  }), _vm._v("Photographer Crunk was on hand and caught the shadows of the old soldiers and their families also. We understand the pictures are excellent.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.33.1.3.box.364.789.579.80.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0"
    }
  }), _vm._v("A Letter From Mr. Emory Sweet "), _c('br'), _vm._v("About the Reunion. "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.4.box.315.924.1099.340.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.0.0"
    }
  }), _vm._v("Editors Leader—You will please allow me space in your columns to thank the members of Company C, their wives and children for the courtesies extended my wife, daughter and self at the reunion on the 24th. No manlier, braver set of men ever lived or died than Tipton county's first company that was organized at the old Clopton Campground, officered by D.J. Wood, James I. Hall, CB. Simonton and Robert Lemmon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.5.box.317.1273.1097.289.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.1.0"
    }
  }), _vm._v("I wish you could have seen the ten battle-scarred veterans and their families on the 24th and especially when Joe Forsyth announced dinner. Sloan and Jim were always regarded by the boys as GOOD FIGHTERS and eaters as Company C had, but we now consider them the BEST EATERS and not such good fighters.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.6.box.317.1572.1098.286.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.2.0"
    }
  }), _vm._v("Capts. Hall, Simonton and Jim Lemmon have always occupied a warm place in my heart, but their generous hospitality at the reunion has placed me under lasting obligations to them, their noble wives, accomplished daughters and worthy sons will ever by remembered by Mrs. Sweet and my daughter as an oasis in the desert of life that eternity can not eradicate.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.7.box.317.1869.1099.379.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.3.0"
    }
  }), _vm._v("Well do I remember as if but yesterday thirty-five years ago last May at old Clopton, when we bade adieu to mothers, fathers, sisters, brothers wives and sweethearts, amid tears and prayers, for Jackson, Tenn. We felt then we could whip \"16 to 1,\" but ere a few weeks death furloughed Dan Calhoun. Dan was the pride of Company C We will never forget Dan's death; he was the first member of Company C who sickened and died. More anon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    attrs: {
      "id": "para.33.1.8.box.367.2317.581.89.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _vm._v("Forrest City, Ark., Sept. 28, 1896 "), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  }), _c('br'), _vm._v("Emory Sweet "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.34.0.0.box.214.564.1303.1357.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0020.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.2"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9068dac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0021.vue
// module id = 72
// module chunks = 0